/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { WhseJob06IndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const whseJob06IndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  fetchIsLoading: false
});

export const whseJob06IndexFetchWhseJob06IndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const whseJob06IndexFetchWhseJob06IndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const whseJob06IndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ].slice(0, 5)
  };
};

export const whseJob06IndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const whseJob06IndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [WhseJob06IndexTypes.WHSE_JOB06_INDEX_RESET_TIMESTAMP]: whseJob06IndexResetTimestamp,
  [WhseJob06IndexTypes.WHSE_JOB06_INDEX_FETCH_WHSE_JOB06_INDEX_LOADING]: whseJob06IndexFetchWhseJob06IndexLoading,
  [WhseJob06IndexTypes.WHSE_JOB06_INDEX_FETCH_WHSE_JOB06_INDEX_SUCCESS]: whseJob06IndexFetchWhseJob06IndexSuccess,
  [WhseJob06IndexTypes.WHSE_JOB06_INDEX_ADD_SELECTED_DOCUMENTS]: whseJob06IndexAddSelectedDocuments,
  [WhseJob06IndexTypes.WHSE_JOB06_INDEX_REMOVE_SELECTED_DOCUMENTS]: whseJob06IndexRemoveSelectedDocuments,
  [WhseJob06IndexTypes.WHSE_JOB06_INDEX_SET_WORKSPACE_VISIBLE]: whseJob06IndexSetWorkspaceVisible
});
